var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cr-divider_wrapper",class:{ 'cr-divider_no-space': _vm.noSpace }},[(_vm.text)?_c('div',{staticClass:"cr-divider-text"},[_vm._v(" "+_vm._s(_vm.text)+" ")]):_vm._e(),_c('div',{staticClass:"cr-divider-line"})])}
var staticRenderFns = []

export { render, staticRenderFns }